var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.type,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.callback($event)}}},[_c('i',{class:_vm.right_icon}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('i',{class:_vm.left_icon})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2afec9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LTEButton.vue
// module id = null
// module chunks = 